const dropdown = document.querySelectorAll('.dropdown');
const dropdownButton = document.querySelectorAll('.dropdown-button');

for (let index = 0; index < dropdownButton.length; index++) {
    const element = dropdown[index];
    const elementButton = dropdownButton[index];

    elementButton.addEventListener('click', () => {
        dropdown.forEach((dropdownElement) => {
            if (dropdownElement !== element) {
                dropdownElement.classList.remove('active');
                dropdownElement.classList.add('closed');
            }
        });
        element.classList.toggle('active');
        element.classList.toggle('closed');
    });
}

const mb = document.querySelectorAll('.mb');
const mbOpen = document.querySelectorAll('.mb-button');

for (let index = 0; index < mbOpen.length; index++) {
    const element = mb[0];
    const elementButton = mbOpen[index];
    elementButton.addEventListener('click', () => {
        element.classList.toggle('active');
        element.classList.toggle('closed');
    });
}

const dropdownmb = document.querySelectorAll('.dropdownmb');
const dropdownButtonmb = document.querySelectorAll('.dropdown-buttonmb');

for (let index = 0; index < dropdownButtonmb.length; index++) {
    const element = dropdownmb[index];
    const elementButton = dropdownButtonmb[index];
    elementButton.addEventListener('click', () => {
        element.classList.toggle('active');
        element.classList.toggle('closed'); 
    });
}

const parentElement = document.getElementById('form-tabs');
const childrenElements = parentElement.children;

for (let i = 0; i < childrenElements.length; i++) {
    childrenElements[i].addEventListener('click', () => {
        for (let j = 0; j < childrenElements.length; j++) {
            childrenElements[j].classList.remove('active');
        }
        childrenElements[i].classList.add('active');
        const otherParentElement = document.getElementById('form-content-tab');
        const otherChildElement = otherParentElement.children[i];

        for (let k = 0; k < otherParentElement.children.length; k++) {
            otherParentElement.children[k].classList.remove('active');
        }

        otherChildElement.classList.add('active');
    });
}